import { useRoute, useRuntimeConfig } from '#imports'
import { computed, ref } from 'vue'

import { voteForArticle } from '@backmarket/http-api/src/api-specs-content/endpoints'
import type { Vote } from '@backmarket/http-api/src/api-specs-content/models/article-votes'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import { usePageParamsFromRoute } from '~/scopes/cms/composables/usePageParamsFromRoute'

export function useVoteForArticle() {
  const { openErrorToast } = useTheToast()
  const logger = useLogger()
  const route = useRoute()
  const $httpFetchV2 = useHttpFetch()
  const {
    public: { FF_CMS_USE_NEW_ARTICLE_VOTES_ENDPOINT: newVotesEndpoint },
  } = useRuntimeConfig()
  const { pageName, pageType } = usePageParamsFromRoute()

  const userVote = ref<Vote>()

  const hasVoted = computed(() => !!userVote.value)

  async function postVoteForArticle(vote: Vote) {
    const articleSlug = route.params.pageName

    const previousValue = userVote.value
    userVote.value = vote
    try {
      if (newVotesEndpoint) {
        await $httpFetchV2('/content/page/:pageType/:pageName/votes', {
          method: 'POST',
          pathParams: { pageType, pageName },
          body: { vote },
        })
      } else {
        await $httpFetch(voteForArticle, {
          pathParams: { articleSlug },
          body: { vote },
        })
      }
    } catch (err) {
      userVote.value = previousValue
      openErrorToast()

      const error = err as Error
      logger.error('[ACQ] Error when posting a vote for an article', {
        error,
        owners: ['bot-squad-content-front'],
      })
    }
  }

  return { postVoteForArticle, userVote, hasVoted }
}
